import { createEntityAdapter, EntityAdapter, EntityState, Update } from '@ngrx/entity';

import * as notifications from './notifications.actions';
import { Notification } from './notifications.interface';

export interface NotificationsState extends EntityState<Notification> { }

export function selectNotificationId(a: Notification): string {
	return a.id;
}

export function sortByTimestampDesc(a: Notification, b: Notification): number {
	return b.timestamp - a.timestamp;
}

export const notificationAdapter: EntityAdapter<Notification> = createEntityAdapter<Notification>({
	selectId: selectNotificationId,
	sortComparer: sortByTimestampDesc
});

export const initialState: NotificationsState = notificationAdapter.getInitialState();

export function reducer(state = initialState, action: notifications.Actions): NotificationsState {
	switch (action.type) {
		case notifications.ADD_NEW_NOTIFICATION: {
			return notificationAdapter.addOne(action.payload, state);
		}
		case notifications.DISMISS_NOTIFICATION: {
			const update: Update<Notification> = {
				id: action.payload,
				changes: { isDismissed: true }
			};

			return notificationAdapter.updateOne(update, state);
		}
		default: {
			return state;
		}
	}
}
